import { DEFAULT_VALUE, MAX_VALUE, MIN_VALUE } from './constants';

export function getNormalizedValue(gte: number | undefined): number {
  if (gte === undefined) {
    return DEFAULT_VALUE;
  }

  return Math.max(MIN_VALUE, Math.min(MAX_VALUE, gte));
}
